/**
 * @generated SignedSource<<ac33b5d62b5bb8871cac2afa0066e470>>
 * @relayHash fefb7ed8a972b0aa600d0349b65faaa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 512603ef10f340fc5ebfb14f164be0c937daccf5fff4b49ad8ce282402c44b4b

var node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "commentId"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "issueKey"
    },
    v3 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }, {
      "kind": "Variable",
      "name": "key",
      "variableName": "issueKey"
    }],
    v4 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v5 = {
      "kind": "ScalarField",
      "name": "projectType"
    },
    v6 = {
      "kind": "ScalarField",
      "name": "projectId"
    },
    v7 = {
      "alias": "canAddComments",
      "args": [{
        "kind": "Literal",
        "name": "permission",
        "value": "ADD_COMMENTS"
      }],
      "kind": "ScalarField",
      "name": "hasProjectPermission",
      "storageKey": "hasProjectPermission(permission:\"ADD_COMMENTS\")"
    },
    v8 = [{
      "kind": "Literal",
      "name": "afterTarget",
      "value": 1
    }, {
      "kind": "Literal",
      "name": "beforeTarget",
      "value": 0
    }, {
      "kind": "Variable",
      "name": "targetId",
      "variableName": "commentId"
    }],
    v9 = {
      "kind": "ScalarField",
      "name": "commentId"
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],
      "kind": "Fragment",
      "name": "mainIssueDatatwoQuery",
      "selections": [{
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [{
          "args": v3 /*: any*/,
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issueByKey",
          "plural": false,
          "selections": [v4 /*: any*/, {
            "concreteType": "JiraProjectField",
            "kind": "LinkedField",
            "name": "projectField",
            "plural": false,
            "selections": [{
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [v5 /*: any*/, v6 /*: any*/]
            }]
          }, v7 /*: any*/, {
            "args": v8 /*: any*/,
            "concreteType": "JiraCommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [{
              "concreteType": "JiraCommentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [v9 /*: any*/]
              }]
            }]
          }]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v2 /*: any*/, v1 /*: any*/, v0 /*: any*/],
      "kind": "Operation",
      "name": "mainIssueDatatwoQuery",
      "selections": [{
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [{
          "args": v3 /*: any*/,
          "concreteType": "JiraIssue",
          "kind": "LinkedField",
          "name": "issueByKey",
          "plural": false,
          "selections": [v4 /*: any*/, {
            "concreteType": "JiraProjectField",
            "kind": "LinkedField",
            "name": "projectField",
            "plural": false,
            "selections": [{
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [v5 /*: any*/, v6 /*: any*/, v4 /*: any*/]
            }, v4 /*: any*/]
          }, v7 /*: any*/, {
            "args": v8 /*: any*/,
            "concreteType": "JiraCommentConnection",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [{
              "concreteType": "JiraCommentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "name": "__typename"
                }, v9 /*: any*/, {
                  "kind": "InlineFragment",
                  "selections": [v4 /*: any*/],
                  "type": "Node",
                  "abstractKey": "__isNode"
                }]
              }]
            }]
          }]
        }]
      }]
    },
    "params": {
      "id": "512603ef10f340fc5ebfb14f164be0c937daccf5fff4b49ad8ce282402c44b4b",
      "metadata": {},
      "name": "mainIssueDatatwoQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "a19cc13eee2b6098fe48fb11d61a5a34";
export default node;